import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useSendMessage(): (
  text: string,
  method?: string,
  { channelData }?: { channelData?: any }
) => void {
  return useWebChatAPIContext().sendMessage;
}
